import { PackageCheck } from "lucide-react";
import Reveal from "./Reveal";
import { Sticker } from "./Stickers";

export default function BothSides() {
  return (
    <section id="both-sides" className="py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-16">
        <Reveal>
          <div className="flex items-end justify-between gap-6 border-b-2 border-ink pb-6">
            <h2 className="font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-ink md:text-6xl">
              Made for{" "}
              <span className="relative inline-block -rotate-1">
                <span className="relative z-10 italic">both sides.</span>
                <span className="absolute inset-x-[-4px] bottom-[0.08em] z-0 h-[38%] bg-pastel-pink" />
              </span>
            </h2>
            <span className="mb-1 hidden h-14 w-14 items-center justify-center rounded-xl border-2 border-ink bg-white shadow-chunk sm:flex">
              <PackageCheck className="h-6 w-6" strokeWidth={1.75} />
            </span>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-8 md:mt-14 md:grid-cols-2">
          <Reveal className="h-full">
            <div
              className="flex h-full flex-col rounded-2xl border-2 border-ink bg-ink p-8 text-bone shadow-chunk-lg transition-transform duration-300 hover:rotate-0 md:-rotate-1 md:p-12"
              data-testid="both-sides-artists"
            >
              <Sticker rotate="-rotate-2" bg="bg-pastel-mint">
                For artists
              </Sticker>
              <h3 className="mt-10 font-display text-3xl font-extrabold leading-[1.05] tracking-tight md:mt-14 md:text-5xl">
                Your business has a new rhythm.
              </h3>
              <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-bone/70 md:mt-auto md:pt-14">
                Dashboard, orders, styles, analytics, notes, and integrations —
                calmly connected from first order to final ship.
              </p>
              <div className="mt-10 flex md:justify-end">
                <span className="flex h-24 w-24 items-center justify-center rounded-full border border-bone/40">
                  <PackageCheck className="h-9 w-9" strokeWidth={1.25} />
                </span>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="h-full">
            <div
              className="flex h-full flex-col rounded-2xl border-2 border-ink bg-pastel-blue p-8 text-ink shadow-chunk-lg transition-transform duration-300 hover:rotate-0 md:rotate-1 md:p-12"
              data-testid="both-sides-clients"
            >
              <Sticker rotate="rotate-2" bg="bg-white">
                For clients
              </Sticker>
              <h3 className="mt-10 font-display text-3xl font-extrabold leading-[1.05] tracking-tight md:mt-14 md:text-5xl">
                One job, done beautifully.
              </h3>
              <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-ink/70 md:mt-auto md:pt-14">
                Enter the ProCode, measure, send, and get updates until the set
                arrives. No account maze. No uncertainty.
              </p>
              <div className="mt-10 flex md:justify-end">
                <div className="flex items-baseline gap-3 rounded-lg border-2 border-ink bg-bone px-5 py-3.5 shadow-chunk">
                  <span className="font-sans text-[11px] font-bold uppercase tracking-[0.2em]">
                    ProCode
                  </span>
                  <span className="font-georgia text-xl italic">MIA-042</span>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
